import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createConnectionConversion, deleteConnectionConversion, fetchConnectionConversions, updateConnectionConversion, } from '../../common/jsonstore';
import { ConnectionConversion } from '../../common/model';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';
import { AppState } from '../../redux/store/rootReducer';

export interface IAuthentication {
  ConnectionConversion: ConnectionConversion[];
  success: any;
  isProcessingComplete: boolean;
}

const initialState: IAuthentication = { ConnectionConversion: [], success: {}, isProcessingComplete: false };

const ConnectionConversionSlice = createSlice({
  name: 'ConnectionConversions',
  initialState,
  reducers: {
    receiveConnectionConversion: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        ConnectionConversion: action.payload,
        isProcessingComplete: false
      };
    },
    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});


export const loadConnectionConversions = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const ConnectionConversions = await fetchConnectionConversions().then((res: any) => {
      dispatch(ConnectionConversionSlice.actions.receiveConnectionConversion(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Data not loaded';
        handleError(msg);
      }
    });
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addConnectionConversion = (newConnectionConversion: ConnectionConversion): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await createConnectionConversion(newConnectionConversion).then((resp: any) => {
      dispatch(ConnectionConversionSlice.actions.receiveConnectionConversion(resp.data));
      dispatch(ConnectionConversionSlice.actions.success({ 'sts': true, data: 'Data Added Successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Data Not Added';
        handleError(msg);
        // dispatch(ConnectionConversionSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyConnectionConversion = (newConnectionConversion: ConnectionConversion, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await updateConnectionConversion(newConnectionConversion, id).then((resp: any) => {
      const resData = resp?.data && resp.data.length > 0 ? resp.data[0] : {};
      const updatedData = getState().ConnectionConversions.ConnectionConversion.map(el => (el.id === id ? resData : el))
      dispatch(ConnectionConversionSlice.actions.receiveConnectionConversion(updatedData));
      // dispatch(ConnectionConversionSlice.actions.receiveConnectionConversion(resp.data));
      dispatch(ConnectionConversionSlice.actions.success({ 'sts': true, data: 'Data updated Successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Data Not Updated';
        handleError(msg);
        // dispatch(ConnectionConversionSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeConnectionConversion = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    await deleteConnectionConversion(id).then((res:any) => {
      const updatedData = getState().ConnectionConversions.ConnectionConversion.filter((item:any) => item.id !== id);
      dispatch(ConnectionConversionSlice.actions.receiveConnectionConversion(updatedData))
      dispatch(ConnectionConversionSlice.actions.success({ 'sts': true, data: 'Data deleted Successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      }
      else {
        let msg = ''
          msg = err?.response?.data?.msg
        dispatch(ConnectionConversionSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(ConnectionConversionSlice.actions.success(data));
}

export default ConnectionConversionSlice.reducer;
